import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getVehicleCount } from 'selectors'
import { GARAGE_PAGE } from 'constant'
import { getLocationPathname } from 'selectors/getPageLocation'
import AccountMenuNavigation from './AccountMenuNavigation'
import withSticky from 'components/common/hoc/withSticky'

const mapStateToProps = state => ({
  pathname: getLocationPathname(state),
  vehicleCount: getVehicleCount(state)
})

const withMenu = withProps(({ links = [], vehicleCount }) => ({
  menu: links.map(({ displayName, link: { path }, appointmentsCount }) => ({
    title: displayName,
    url: path,
    value: path === GARAGE_PAGE && vehicleCount > 0 ? vehicleCount : appointmentsCount || null
  }))
}))

export default compose(
  withType({ type: 'AccountMenuNavigartion' }),
  connect(mapStateToProps),
  withMenu,
  withSticky
)(AccountMenuNavigation)
